import { Body } from "@red-digital/bricks";
import React from "react";
import ltoStyles from "./LTO.module.scss";

interface TimeBlockProps {
  value: number;
  label: string;
}

export const TimeBlock: React.FC<TimeBlockProps> = ({ label, value }) => {
  if (isNaN(value)) return null;

  return (
    <div className={ltoStyles.timeblock}>
      <Body variant="caption-lg" modifier={500}>
        {value < 10 ? `0${value}` : value}
      </Body>
      <Body variant="caption-md" modifier={500}>
        {label}
      </Body>
    </div>
  );
};
